
import {
  SET_TESTIMONIAL,
  CREATE_TESTIMONIAL,
  TESTIMONIALS_RECEIVED,
  SET_PROPERTY_TESTIMONIAL,
} from "../types/testimonials";

const schema = {

}

const testimonialsReducer = (state, { type, payload }) => {
  switch (type) {
    case TESTIMONIALS_RECEIVED:
      return { ...state, testimonials: payload };
    case SET_TESTIMONIAL:
      return { ...state, testimonial: payload };
    case CREATE_TESTIMONIAL:
      return { ...state, testimonial: schema };
    case SET_PROPERTY_TESTIMONIAL: {
      const { key, value } = payload;
      const testimonial = { ...state.testimonial };
      testimonial[key] = value;
      return { ...state, testimonial };
    }
    default:
      return { ...state};
  }
};

export default testimonialsReducer;
